import { Component, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { PanAppState, PlatformService } from '@panamax/app-state';
import { PaymentsBasePage } from '@payments/payments-shared/payments-base/payments-base.page';
import { PaymentsService } from '@payments/services/payments.service';
import { FormControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-ach-form-retrieval',
  templateUrl: './ach-form-retrieval.page.html',
  styleUrls: ['./ach-form-retrieval.page.scss'],
})
export class AchFormRetrievalPage
  extends PaymentsBasePage
  implements OnDestroy
{
  auditIdControl = new FormControl('');
  private destroy$ = new Subject<void>();
  isAR$ = this.paymentsService.isUSFoodsAR();

  constructor(
    readonly platformService: PlatformService,
    public router: Router,
    readonly route: ActivatedRoute,
    readonly paymentsService: PaymentsService,
    readonly panAppState: PanAppState,
  ) {
    super(router, route, paymentsService);
  }
  // ag-todo: use browser page title enum
  ionViewWillEnter(): void {
    super.ionViewWillEnter();
    this.panAppState.setPageTitle('Autopay Setup Form Retrieval | US Foods');
  }

  getGeneratedACHFormID(auditId: string): void {
    if (!auditId?.trim()) {
      return;
    }
    // TODO: Implement form retrieval logic
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
